export default "__VITE_ASSET__Bvm$Fk7W__"